// extracted by mini-css-extract-plugin
export default {"wrapper":"ai-subtitles-editor-info_wrapper__LnTAL","section":"ai-subtitles-editor-info_section__uVVli","labelWithIcon":"ai-subtitles-editor-info_labelWithIcon__0ctOK"};